import { render, staticRenderFns } from "./VSpecialOpeningHour.vue?vue&type=template&id=1351447e"
import script from "./VSpecialOpeningHour.vue?vue&type=script&lang=ts"
export * from "./VSpecialOpeningHour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports